export default "__VITE_PUBLIC_ASSET__d2876ecd__"